(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/pay-lyckoplatsen/assets/javascripts/fetch-draw-data.js') >= 0) return;  svs.modules.push('/components/tur/pay-lyckoplatsen/assets/javascripts/fetch-draw-data.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const NUMBER_OF_PRIMARY_DRAWS_PER_WEEK = 1;
const NUMBER_OF_SECONDARY_DRAWS_PER_WEEK = 2;
const drawgamesApiCaller = svs.tur.apiCaller.drawgames;
async function fetchDrawData(numberOfWeeks) {
  const _await$Promise$all = await Promise.all([drawgamesApiCaller.getDrawProductDraws({
      product: 'lyckoplatsenprimary'
    }), drawgamesApiCaller.getDrawProductDraws({
      product: 'lyckoplatsensecondary'
    })]),
    _await$Promise$all2 = _slicedToArray(_await$Promise$all, 2),
    geo1 = _await$Promise$all2[0],
    geo2 = _await$Promise$all2[1];
  const primaryDraw = geo1.response.draws.currentDraw;
  const secondaryDraw = geo2.response.draws[0];
  const _sort = [primaryDraw, secondaryDraw].sort((a, b) => new Date(a.regCloseTime) - new Date(b.regCloseTime)),
    _sort2 = _slicedToArray(_sort, 1),
    firstDraw = _sort2[0];
  const primaryDrawNumber = primaryDraw.drawNumber + (NUMBER_OF_PRIMARY_DRAWS_PER_WEEK * numberOfWeeks - 1);
  const secondaryDrawNumber = secondaryDraw.drawNumber + (NUMBER_OF_SECONDARY_DRAWS_PER_WEEK * numberOfWeeks - 1);
  const _await$Promise$all3 = await Promise.all([drawgamesApiCaller.getDrawProductDrawsByDrawNumber({
      product: 'lyckoplatsenprimary',
      drawNumber: primaryDrawNumber
    }), drawgamesApiCaller.getDrawProductDrawsByDrawNumber({
      product: 'lyckoplatsensecondary',
      drawNumber: secondaryDrawNumber
    })]),
    _await$Promise$all4 = _slicedToArray(_await$Promise$all3, 2),
    furuteGeo1 = _await$Promise$all4[0],
    furuteGeo2 = _await$Promise$all4[1];
  const _sort3 = [furuteGeo1.response.draw, furuteGeo2.response.draw].sort((a, b) => new Date(b.regCloseTime) - new Date(a.regCloseTime)),
    _sort4 = _slicedToArray(_sort3, 1),
    lastDraw = _sort4[0];
  return {
    primaryDraw,
    secondaryDraw,
    firstDraw,
    lastDraw
  };
}
async function getDrawData(_ref) {
  let next = _ref.next,
    numberOfWeeks = _ref.numberOfWeeks;
  const _await$fetchDrawData = await fetchDrawData(numberOfWeeks),
    primaryDraw = _await$fetchDrawData.primaryDraw,
    secondaryDraw = _await$fetchDrawData.secondaryDraw,
    firstDraw = _await$fetchDrawData.firstDraw,
    lastDraw = _await$fetchDrawData.lastDraw;
  next({
    primaryDraw,
    secondaryDraw,
    firstDraw,
    lastDraw
  });
}
setGlobal('svs.tur.pay_lyckoplatsen', {
  fetchDrawData,
  getDrawData
});

 })(window);